import useStrings from "../../localization/useStrings"
import useQueryParams from "../../hooks/useQueryParams"
import useHasPro from "../../hooks/useHasPro"
import { usePurchase } from "../../context/purchaseContext"

export const useThreeStepStrings = () => {
  const strings = useStrings()
  const { showUltimateInExpiration, isSubscriptionExpiration } =
    useQueryParams()
  const hasPro = useHasPro()
  const { state: purchaseState } = usePurchase()

  const isUltimate = purchaseState.ultimateSelected

  const getTitle = () => {
    if (!hasPro && !isSubscriptionExpiration) {
      return strings.threeStepExpiration.freeExpired
    }
    return isUltimate
      ? strings.threeStepExpiration.ultimateExpired
      : strings.threeStepExpiration.premiumExpired
  }

  const getSubtitle = () => {
    if (hasPro) {
      return strings.threeStepExpiration.subtitle
    }
    if (!showUltimateInExpiration) {
      return strings.threeStepExpiration.subtitle
    }
    return isUltimate
      ? strings.threeStepExpiration.subtitleUltimate
      : strings.threeStepExpiration.subtitlePremium
  }

  const title = getTitle()

  return {
    title,
    subtitle: getSubtitle(),
    basicSection: {
      title: hasPro
        ? strings.bubbleExpiration.proTitle
        : strings.bubbleExpiration.basicTitle,
      badge: hasPro
        ? strings.bubbleExpiration.purchased
        : strings.bubbleExpiration.free,
      description: hasPro
        ? strings.bubbleExpiration.proDescription
        : strings.bubbleExpiration.basicDescription,
      cta: hasPro
        ? strings.bubbleExpiration.switchToPro
        : strings.bubbleExpiration.switchToBasic,
    },
  }
}
